import React, { useState, useEffect, useRef, useMemo } from "react";
import {
  FiSettings,
  FiRefreshCw,
  FiChevronUp,
  FiChevronDown,
  FiCheck,
  // FiX,
  // FiDownload,
  // FiUpload,
  // FiSave,
  // FiTrash2,
  // FiCopy,
  // FiPalette
} from 'react-icons/fi';

// Mock useTheme hook for demonstration - replace with your actual implementation
const useTheme = () => ({
  theme: {
    mode: "light",
    accent: "#007bff",
    bg: "#ffffff",
    fontSize: 16,
    fontFamily: "system",
    buttonShape: "rounded",
    spacing: "comfortable",
    animations: "smooth"
  },
  setMode: (mode) => console.log('setMode:', mode),
  setAccent: (accent) => console.log('setAccent:', accent),
  setFontSize: (size) => console.log('setFontSize:', size),
  setFontFamily: (family) => console.log('setFontFamily:', family),
  setButtonShape: (shape) => console.log('setButtonShape:', shape),
  setSpacing: (spacing) => console.log('setSpacing:', spacing),
  setAnimations: (animations) => console.log('setAnimations:', animations),
  resetTheme: () => console.log('resetTheme')
});

// SVG Icons as React components (replacing react-icons/fi)
const IconDownload = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3"/>
  </svg>
);

const IconUpload = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12"/>
  </svg>
);

const IconSave = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/>
    <polyline points="17,21 17,13 7,13 7,21"/>
    <polyline points="7,3 7,8 15,8"/>
  </svg>
);

// eslint-disable-next-line no-unused-vars
const IconRefresh = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="23,4 23,10 17,10"/>
    <polyline points="1,20 1,14 7,14"/>
    <path d="m20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4-4.64 4.36A9 9 0 0 1 3.51 15"/>
  </svg>
);

const IconEye = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
    <circle cx="12" cy="12" r="3"/>
  </svg>
);

const IconSun = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="12" r="5"/>
    <line x1="12" y1="1" x2="12" y2="3"/>
    <line x1="12" y1="21" x2="12" y2="23"/>
    <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/>
    <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
    <line x1="1" y1="12" x2="3" y2="12"/>
    <line x1="21" y1="12" x2="23" y2="12"/>
    <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/>
    <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
  </svg>
);

const IconMoon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
  </svg>
);

const IconMonitor = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
    <line x1="8" y1="21" x2="16" y2="21"/>
    <line x1="12" y1="17" x2="12" y2="21"/>
  </svg>
);

const IconPalette = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="13.5" cy="6.5" r=".5"/>
    <circle cx="17.5" cy="10.5" r=".5"/>
    <circle cx="8.5" cy="7.5" r=".5"/>
    <circle cx="6.5" cy="12.5" r=".5"/>
    <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z"/>
  </svg>
);

const IconSettings = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="12" r="3"/>
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1 1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/>
  </svg>
);

const IconType = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="4,7 4,4 20,4 20,7"/>
    <line x1="9" y1="20" x2="15" y2="20"/>
    <line x1="12" y1="4" x2="12" y2="20"/>
  </svg>
);

const IconLayout = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
    <line x1="9" y1="9" x2="21" y2="9"/>
    <line x1="9" y1="21" x2="9" y2="9"/>
  </svg>
);

const IconZap = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polygon points="13,2 3,14 12,14 11,22 21,10 12,10 13,2"/>
  </svg>
);

const IconCheck = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="20,6 9,17 4,12"/>
  </svg>
);

const IconAlertTriangle = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
    <line x1="12" y1="9" x2="12" y2="13"/>
    <line x1="12" y1="17" x2="12.01" y2="17"/>
  </svg>
);

// eslint-disable-next-line no-unused-vars
const IconChevronDown = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="6,9 12,15 18,9"/>
  </svg>
);

// eslint-disable-next-line no-unused-vars
const IconChevronUp = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="18,15 12,9 6,15"/>
  </svg>
);

const IconTrash = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="3,6 5,6 21,6"/>
    <path d="M19,6v14a2 2 0 0 1-2,2H7a2 2 0 0 1-2-2V6m3,0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2,2v2"/>
    <line x1="10" y1="11" x2="10" y2="17"/>
    <line x1="14" y1="11" x2="14" y2="17"/>
  </svg>
);

// Enhanced configuration with semantic color tokens
const THEME_PRESETS = {
  professional: { name: "Professional", accent: "#2563eb", bg: "#ffffff", description: "Clean and corporate" },
  creative: { name: "Creative", accent: "#ec4899", bg: "#fefefe", description: "Vibrant and inspiring" },
  nature: { name: "Nature", accent: "#059669", bg: "#f0fdf4", description: "Calm and organic" },
  sunset: { name: "Sunset", accent: "#ea580c", bg: "#fff7ed", description: "Warm and energetic" },
  minimalist: { name: "Minimalist", accent: "#374151", bg: "#ffffff", description: "Simple and focused" },
  retro: { name: "Retro", accent: "#7c3aed", bg: "#faf5ff", description: "Nostalgic vibes" }
};

const ACCESSIBILITY_LEVELS = {
  aa: { name: "WCAG AA", ratio: 4.5, description: "Standard compliance" },
  aaa: { name: "WCAG AAA", ratio: 7, description: "Enhanced compliance" }
};

const ANIMATION_PRESETS = {
  none: { name: "None", duration: "0ms", easing: "linear" },
  subtle: { name: "Subtle", duration: "150ms", easing: "ease-out" },
  smooth: { name: "Smooth", duration: "250ms", easing: "cubic-bezier(0.4, 0, 0.2, 1)" },
  bouncy: { name: "Bouncy", duration: "300ms", easing: "cubic-bezier(0.68, -0.55, 0.265, 1.55)" }
};

const SPACING_SCALES = {
  compact: { name: "Compact", base: "0.75rem", scale: 0.75 },
  comfortable: { name: "Comfortable", base: "1rem", scale: 1 },
  spacious: { name: "Spacious", base: "1.25rem", scale: 1.25 }
};

// Utility functions (enhanced)
const colorUtils = {
  hexToRgb: (hex) => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  },

  rgbToHsl: (r, g, b) => {
 r /= 255; g /= 255; b /= 255;
 const max = Math.max(r, g, b), min = Math.min(r, g, b);
 let h, s, l = (max + min) / 2;

 if (max === min) {
   h = s = 0;
 } else {
   const d = max - min;
   s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
   switch (max) {
     case r: h = (g - b) / d + (g < b ? 6 : 0); break;
     case g: h = (b - r) / d + 2; break;
     case b: h = (r - g) / d + 4; break;
     default: break;
   }
   h /= 6;
 }
 return { h: h * 360, s: s * 100, l: l * 100 };
},

  getContrastRatio: (hex1, hex2) => {
    const getLuminance = (hex) => {
      const rgb = colorUtils.hexToRgb(hex);
      if (!rgb) return 0;
      const [r, g, b] = [rgb.r, rgb.g, rgb.b].map(c => {
        c = c / 255;
        return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
      });
      return 0.2126 * r + 0.7152 * g + 0.0722 * b;
    };

    const lum1 = getLuminance(hex1);
    const lum2 = getLuminance(hex2);
    return (Math.max(lum1, lum2) + 0.05) / (Math.min(lum1, lum2) + 0.05);
  },

  generatePalette: (baseColor) => {
    const rgb = colorUtils.hexToRgb(baseColor);
    if (!rgb) return [baseColor];
    
    const hsl = colorUtils.rgbToHsl(rgb.r, rgb.g, rgb.b);
    const palette = [];
    
    // Generate lighter and darker variants
    for (let i = -3; i <= 3; i++) {
      const lightness = Math.max(10, Math.min(90, hsl.l + (i * 15)));
      const newColor = `hsl(${Math.round(hsl.h)}, ${Math.round(hsl.s)}%, ${Math.round(lightness)}%)`;
      palette.push(newColor);
    }
    
    return palette;
  }
};

// Enhanced Theme Customizer Component
const EnhancedThemeCustomizer = () => {
  const {
    theme,
    setMode,
    setAccent,
    setFontSize,
    setFontFamily,
    setButtonShape,
    setSpacing,
    setAnimations,
    resetTheme
  } = useTheme();

  // Enhanced state management
  const [activeTab, setActiveTab] = useState('colors');
  const [customAccent, setCustomAccent] = useState(theme.accent || "#007bff");
  const [customBg, setCustomBg] = useState(theme.bg || "#ffffff");
  const [showAdvanced, setShowAdvanced] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [previewMode, setPreviewMode] = useState(false);
  const [savedThemes, setSavedThemes] = useState([]);
  const [themeName, setThemeName] = useState('');
  const [colorPalette, setColorPalette] = useState([]);
  const [showToast, setShowToast] = useState(null);
  const fileInputRef = useRef(null);

  // Generate color palette when accent changes
  useEffect(() => {
    setColorPalette(colorUtils.generatePalette(customAccent));
  }, [customAccent]);

  // Load saved themes from localStorage
  useEffect(() => {
    try {
      const saved = localStorage.getItem('saved-themes');
      if (saved) {
        setSavedThemes(JSON.parse(saved));
      }
    } catch (error) {
      console.warn('Failed to load saved themes:', error);
    }
  }, []);

  // Auto-hide toast
  useEffect(() => {
    if (showToast) {
      const timer = setTimeout(() => setShowToast(null), 3000);
      return () => clearTimeout(timer);
    }
  }, [showToast]);

  // Accessibility analysis
  const accessibilityAnalysis = useMemo(() => {
    const contrastRatio = colorUtils.getContrastRatio(customAccent, customBg);
    const isAACompliant = contrastRatio >= ACCESSIBILITY_LEVELS.aa.ratio;
    const isAAACompliant = contrastRatio >= ACCESSIBILITY_LEVELS.aaa.ratio;
    
    return {
      ratio: contrastRatio.toFixed(2),
      level: isAAACompliant ? 'AAA' : isAACompliant ? 'AA' : 'Fail',
      isCompliant: isAACompliant,
      recommendations: !isAACompliant ? ['Consider using a darker accent color', 'Or try a lighter background'] : []
    };
  }, [customAccent, customBg]);

  // Handlers
  const handleAccentChange = (color) => {
    setCustomAccent(color);
    setAccent(color);
  };

  const handlePresetApply = (preset) => {
    handleAccentChange(preset.accent);
    setCustomBg(preset.bg);
    setShowToast({ type: 'success', message: `Applied ${preset.name} theme!` });
  };

  const handleSaveTheme = () => {
    if (!themeName.trim()) return;
    
    const newTheme = {
      id: Date.now(),
      name: themeName,
      ...theme,
      accent: customAccent,
      bg: customBg,
      createdAt: new Date().toISOString()
    };

    const updated = [...savedThemes, newTheme];
    setSavedThemes(updated);
    localStorage.setItem('saved-themes', JSON.stringify(updated));
    setThemeName('');
    setShowToast({ type: 'success', message: 'Theme saved successfully!' });
  };

  const handleLoadTheme = (savedTheme) => {
    setMode(savedTheme.mode);
    handleAccentChange(savedTheme.accent);
    setCustomBg(savedTheme.bg);
    setFontSize(savedTheme.fontSize);
    setButtonShape(savedTheme.buttonShape);
    setSpacing(savedTheme.spacing);
    setShowToast({ type: 'success', message: `Loaded ${savedTheme.name} theme!` });
  };

  const handleDeleteTheme = (themeId) => {
    const updated = savedThemes.filter(t => t.id !== themeId);
    setSavedThemes(updated);
    localStorage.setItem('saved-themes', JSON.stringify(updated));
    setShowToast({ type: 'success', message: 'Theme deleted!' });
  };

  const handleExportTheme = () => {
    const themeData = {
      ...theme,
      accent: customAccent,
      bg: customBg,
      exportedAt: new Date().toISOString(),
      version: "1.0"
    };
    
    const blob = new Blob([JSON.stringify(themeData, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `theme-${Date.now()}.json`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    setShowToast({ type: 'success', message: 'Theme exported!' });
  };

  const handleImportTheme = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const importedTheme = JSON.parse(e.target.result);
        handleLoadTheme(importedTheme);
        setShowToast({ type: 'success', message: 'Theme imported successfully!' });
      } catch (error) {
        setShowToast({ type: 'error', message: 'Invalid theme file format' });
      }
    };
    reader.readAsText(file);
  };

  const TabButton = ({ id, label, icon: Icon, isActive, onClick }) => (
    <button
      className={`tab-button ${isActive ? 'active' : ''}`}
      onClick={() => onClick(id)}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '12px 16px',
        border: 'none',
        borderRadius: '8px',
        background: isActive ? customAccent : 'transparent',
        color: isActive ? 'white' : '#64748b',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        fontSize: '14px',
        fontWeight: '500'
      }}
    >
      <Icon />
      {label}
    </button>
  );

  const AccessibilityBadge = ({ level, ratio }) => (
    <div style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: '6px',
      padding: '4px 8px',
      borderRadius: '12px',
      fontSize: '12px',
      fontWeight: '600',
      background: level === 'AAA' ? '#dcfce7' : level === 'AA' ? '#fef3c7' : '#fee2e2',
      color: level === 'AAA' ? '#166534' : level === 'AA' ? '#92400e' : '#dc2626'
    }}>
      {level === 'Fail' ? <IconAlertTriangle /> : <IconCheck />}
      {level} ({ratio})
    </div>
  );

  const Toast = ({ type, message }) => (
    <div style={{
      position: 'fixed',
      top: '20px',
      right: '20px',
      background: type === 'error' ? '#ef4444' : '#10b981',
      color: 'white',
      padding: '12px 20px',
      borderRadius: '8px',
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
      zIndex: 1000,
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      animation: 'slideIn 0.3s ease-out'
    }}>
      <IconCheck />
      {message}
    </div>
  );

  return (
    <>
      <style>{`
        @keyframes slideIn {
          from { transform: translateX(100%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
      `}</style>
      
      {showToast && <Toast type={showToast.type} message={showToast.message} />}
      
      <div className="enhanced-theme-customizer" style={{
        maxWidth: '700px',
        margin: '2rem auto',
        background: 'white',
        borderRadius: '16px',
        boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
        overflow: 'hidden'
      }}>
        {/* Header */}
        <div style={{
          padding: '24px',
          borderBottom: '1px solid #e2e8f0',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white'
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <div>
              <h2 style={{ margin: 0, fontSize: '24px', fontWeight: '700' }}>
                <IconPalette style={{ display: 'inline', marginRight: '8px' }} />
                Theme Customizer
              </h2>
              <p style={{ margin: '8px 0 0 0', opacity: 0.9 }}>
                Customize your app's appearance with live preview
              </p>
            </div>
            <div style={{ display: 'flex', gap: '8px' }}>
              <button
                onClick={handleExportTheme}
                style={{
                  background: 'rgba(255,255,255,0.2)',
                  border: 'none',
                  borderRadius: '8px',
                  color: 'white',
                  padding: '8px 12px',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px',
                  fontSize: '12px'
                }}
              >
                <IconDownload />
                Export
              </button>
              <button
                onClick={() => fileInputRef.current?.click()}
                style={{
                  background: 'rgba(255,255,255,0.2)',
                  border: 'none',
                  borderRadius: '8px',
                  color: 'white',
                  padding: '8px 12px',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px',
                  fontSize: '12px'
                }}
              >
                <IconUpload />
                Import
              </button>
              <input
                ref={fileInputRef}
                type="file"
                accept=".json"
                onChange={handleImportTheme}
                style={{ display: 'none' }}
              />
            </div>
          </div>
        </div>

        {/* Navigation Tabs */}
        <div style={{
          display: 'flex',
          padding: '16px 24px 0',
          gap: '8px',
          borderBottom: '1px solid #e2e8f0',
          overflowX: 'auto'
        }}>
          <TabButton id="colors" label="Colors" icon={IconPalette} isActive={activeTab === 'colors'} onClick={setActiveTab} />
          <TabButton id="typography" label="Typography" icon={IconType} isActive={activeTab === 'typography'} onClick={setActiveTab} />
          <TabButton id="layout" label="Layout" icon={IconLayout} isActive={activeTab === 'layout'} onClick={setActiveTab} />
          <TabButton id="effects" label="Effects" icon={IconZap} isActive={activeTab === 'effects'} onClick={setActiveTab} />
          <TabButton id="presets" label="Presets" icon={IconSettings} isActive={activeTab === 'presets'} onClick={setActiveTab} />
        </div>

        {/* Tab Content */}
        <div style={{ padding: '24px' }}>
          {/* Colors Tab */}
          {activeTab === 'colors' && (
            <div className="colors-tab">
              {/* Theme Mode */}
              <div className="control-group" style={{ marginBottom: '24px' }}>
                <label style={{ fontSize: '16px', fontWeight: '600', marginBottom: '12px', display: 'block' }}>
                  Theme Mode
                </label>
                <div style={{ display: 'flex', gap: '8px' }}>
                  {[
                    { value: 'light', label: 'Light', icon: IconSun },
                    { value: 'dark', label: 'Dark', icon: IconMoon },
                    { value: 'system', label: 'System', icon: IconMonitor }
                  ].map(({ value, label, icon: Icon }) => (
                    <button
                      key={value}
                      onClick={() => setMode(value)}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        padding: '12px 16px',
                        border: '2px solid',
                        borderColor: theme.mode === value ? customAccent : '#e2e8f0',
                        borderRadius: '12px',
                        background: theme.mode === value ? `${customAccent}10` : 'white',
                        color: theme.mode === value ? customAccent : '#64748b',
                        cursor: 'pointer',
                        fontSize: '14px',
                        fontWeight: '500',
                        transition: 'all 0.2s ease'
                      }}
                    >
                      <Icon size={16} />
                      {label}
                    </button>
                  ))}
                </div>
              </div>

              {/* Primary Color */}
              <div className="control-group" style={{ marginBottom: '24px' }}>
                <label style={{ fontSize: '16px', fontWeight: '600', marginBottom: '12px', display: 'block' }}>
                  Primary Color Palette
                </label>
                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginBottom: '16px' }}>
                  {colorPalette.map((color, index) => (
                    <button
                      key={index}
                      onClick={() => handleAccentChange(color)}
                      style={{
                        width: '36px',
                        height: '36px',
                        borderRadius: '8px',
                        border: `3px solid ${customAccent === color ? '#000' : 'transparent'}`,
                        background: color,
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        transform: customAccent === color ? 'scale(1.1)' : 'scale(1)',
                        boxShadow: customAccent === color ? '0 4px 12px rgba(0,0,0,0.3)' : 'none'
                      }}
                      title={color}
                    />
                  ))}
                </div>
                <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                  <input
                    type="color"
                    value={customAccent}
                    onChange={(e) => handleAccentChange(e.target.value)}
                    style={{
                      width: '50px',
                      height: '40px',
                      borderRadius: '8px',
                      border: '2px solid #e2e8f0',
                      cursor: 'pointer'
                    }}
                  />
                  <input
                    type="text"
                    value={customAccent}
                    onChange={(e) => handleAccentChange(e.target.value)}
                    style={{
                      flex: 1,
                      padding: '8px 12px',
                      border: '2px solid #e2e8f0',
                      borderRadius: '8px',
                      fontSize: '14px',
                      fontFamily: 'monospace'
                    }}
                  />
                </div>
              </div>

              {/* Accessibility Check */}
              <div className="control-group" style={{ marginBottom: '24px' }}>
                <label style={{ fontSize: '16px', fontWeight: '600', marginBottom: '12px', display: 'block' }}>
                  Accessibility Analysis
                </label>
                <div style={{
                  padding: '16px',
                  background: '#f8fafc',
                  borderRadius: '12px',
                  border: '1px solid #e2e8f0'
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
                    <AccessibilityBadge level={accessibilityAnalysis.level} ratio={accessibilityAnalysis.ratio} />
                    <span style={{ fontSize: '14px', color: '#64748b' }}>
                      Contrast Ratio
                    </span>
                  </div>
                  {accessibilityAnalysis.recommendations.map((rec, index) => (
                    <div key={index} style={{ fontSize: '12px', color: '#ef4444', marginTop: '4px' }}>
                      • {rec}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* Typography Tab */}
          {activeTab === 'typography' && (
            <div className="typography-tab">
              {/* Font Size */}
              <div className="control-group" style={{ marginBottom: '24px' }}>
                <label style={{ fontSize: '16px', fontWeight: '600', marginBottom: '12px', display: 'block' }}>
                  Font Size: {theme.fontSize || 16}px
                </label>
                <div style={{ position: 'relative' }}>
                  <input
                    type="range"
                    min="12"
                    max="24"
                    value={theme.fontSize || 16}
                    onChange={(e) => setFontSize(Number(e.target.value))}
                    style={{
                      width: '100%',
                      height: '8px',
                      borderRadius: '4px',
                      background: `linear-gradient(to right, ${customAccent} 0%, ${customAccent} ${((theme.fontSize - 12) / 12) * 100}%, #e2e8f0 ${((theme.fontSize - 12) / 12) * 100}%, #e2e8f0 100%)`,
                      outline: 'none',
                      cursor: 'pointer',
                      appearance: 'none'
                    }}
                  />
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '8px', fontSize: '12px', color: '#64748b' }}>
                    <span>12px</span>
                    <span>18px</span>
                    <span>24px</span>
                  </div>
                </div>
              </div>

              {/* Font Family */}
              <div className="control-group" style={{ marginBottom: '24px' }}>
                <label style={{ fontSize: '16px', fontWeight: '600', marginBottom: '12px', display: 'block' }}>
                  Font Family
                </label>
                <select
                  value={theme.fontFamily || "system"}
                  onChange={(e) => setFontFamily(e.target.value)}
                  style={{
                    width: '100%',
                    padding: '12px',
                    border: '2px solid #e2e8f0',
                    borderRadius: '8px',
                    fontSize: '14px',
                    background: 'white',
                    cursor: 'pointer'
                  }}
                >
                  <option value="system">System Default</option>
                  <option value="serif">Serif</option>
                  <option value="mono">Monospace</option>
                  <option value="rounded">Rounded</option>
                </select>
                
                {/* Preview Text */}
                <div style={{
                  marginTop: '16px',
                  padding: '16px',
                  background: '#f8fafc',
                  borderRadius: '8px',
                  fontFamily: theme.fontFamily === 'serif' ? 'Georgia, serif' : 
                             theme.fontFamily === 'mono' ? 'monospace' :
                             theme.fontFamily === 'rounded' ? 'system-ui' : 'inherit',
                  fontSize: `${theme.fontSize || 16}px`
                }}>
                  <div style={{ fontWeight: '600', marginBottom: '8px' }}>
                    The quick brown fox jumps over the lazy dog
                  </div>
                  <div style={{ color: '#64748b' }}>
                    This is how your text will appear with the selected font settings.
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Layout Tab */}
          {activeTab === 'layout' && (
            <div className="layout-tab">
              {/* Spacing */}
              <div className="control-group" style={{ marginBottom: '24px' }}>
                <label style={{ fontSize: '16px', fontWeight: '600', marginBottom: '12px', display: 'block' }}>
                  Spacing Scale
                </label>
                <div style={{ display: 'flex', gap: '8px' }}>
                  {Object.entries(SPACING_SCALES).map(([key, { name, description }]) => (
                    <button
                      key={key}
                      onClick={() => setSpacing(key)}
                      style={{
                        flex: 1,
                        padding: '16px 12px',
                        border: '2px solid',
                        borderColor: theme.spacing === key ? customAccent : '#e2e8f0',
                        borderRadius: '12px',
                        background: theme.spacing === key ? `${customAccent}10` : 'white',
                        color: theme.spacing === key ? customAccent : '#64748b',
                        cursor: 'pointer',
                        fontSize: '14px',
                        fontWeight: '500',
                        textAlign: 'center'
                      }}
                    >
                      <div style={{ fontWeight: '600' }}>{name}</div>
                      <div style={{ fontSize: '12px', opacity: 0.8, marginTop: '4px' }}>
                        {SPACING_SCALES[key].base}
                      </div>
                    </button>
                  ))}
                </div>
              </div>

              {/* Button Shape */}
              <div className="control-group" style={{ marginBottom: '24px' }}>
                <label style={{ fontSize: '16px', fontWeight: '600', marginBottom: '12px', display: 'block' }}>
                  Button Style
                </label>
                <div style={{ display: 'flex', gap: '8px' }}>
                  {[
                    { key: 'rounded', label: 'Rounded', radius: '8px' },
                    { key: 'pill', label: 'Pill', radius: '999px' },
                    { key: 'square', label: 'Square', radius: '0px' }
                  ].map(({ key, label, radius }) => (
                    <button
                      key={key}
                      onClick={() => setButtonShape(key)}
                      style={{
                        flex: 1,
                        padding: '12px',
                        border: '2px solid',
                        borderColor: theme.buttonShape === key ? customAccent : '#e2e8f0',
                        borderRadius: radius,
                        background: theme.buttonShape === key ? customAccent : 'white',
                        color: theme.buttonShape === key ? 'white' : '#64748b',
                        cursor: 'pointer',
                        fontSize: '14px',
                        fontWeight: '500',
                        transition: 'all 0.2s ease'
                      }}
                    >
                      {label}
                    </button>
                  ))}
                </div>
              </div>

              {/* Preview Component Layout */}
              <div className="control-group">
                <label style={{ fontSize: '16px', fontWeight: '600', marginBottom: '12px', display: 'block' }}>
                  Layout Preview
                </label>
                <div style={{
                  padding: '20px',
                  background: '#f8fafc',
                  borderRadius: '12px',
                  border: '1px solid #e2e8f0'
                }}>
                  <div style={{ display: 'flex', gap: SPACING_SCALES[theme.spacing || 'comfortable'].base, marginBottom: SPACING_SCALES[theme.spacing || 'comfortable'].base }}>
                    <button style={{
                      background: customAccent,
                      color: 'white',
                      border: 'none',
                      padding: `${SPACING_SCALES[theme.spacing || 'comfortable'].scale * 8}px ${SPACING_SCALES[theme.spacing || 'comfortable'].scale * 16}px`,
                      borderRadius: theme.buttonShape === 'pill' ? '999px' : theme.buttonShape === 'square' ? '0' : '8px',
                      fontSize: '14px',
                      fontWeight: '500',
                      cursor: 'pointer'
                    }}>
                      Primary Button
                    </button>
                    <button style={{
                      background: 'transparent',
                      color: customAccent,
                      border: `2px solid ${customAccent}`,
                      padding: `${SPACING_SCALES[theme.spacing || 'comfortable'].scale * 8}px ${SPACING_SCALES[theme.spacing || 'comfortable'].scale * 16}px`,
                      borderRadius: theme.buttonShape === 'pill' ? '999px' : theme.buttonShape === 'square' ? '0' : '8px',
                      fontSize: '14px',
                      fontWeight: '500',
                      cursor: 'pointer'
                    }}>
                      Secondary Button
                    </button>
                  </div>
                  <div style={{
                    background: 'white',
                    padding: SPACING_SCALES[theme.spacing || 'comfortable'].base,
                    borderRadius: '8px',
                    border: '1px solid #e2e8f0'
                  }}>
                    <div style={{ fontWeight: '600', marginBottom: `${SPACING_SCALES[theme.spacing || 'comfortable'].scale * 8}px` }}>
                      Card Component
                    </div>
                    <div style={{ color: '#64748b', fontSize: '14px' }}>
                      This card shows how your spacing settings affect component layouts.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Effects Tab */}
          {activeTab === 'effects' && (
            <div className="effects-tab">
              {/* Animations */}
              <div className="control-group" style={{ marginBottom: '24px' }}>
                <label style={{ fontSize: '16px', fontWeight: '600', marginBottom: '12px', display: 'block' }}>
                  Animation Settings
                </label>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  {Object.entries(ANIMATION_PRESETS).map(([key, { name, duration, easing }]) => (
                    <button
                      key={key}
                      onClick={() => setAnimations(key)}
                      style={{
                        padding: '16px',
                        border: '2px solid',
                        borderColor: theme.animations === key ? customAccent : '#e2e8f0',
                        borderRadius: '12px',
                        background: theme.animations === key ? `${customAccent}10` : 'white',
                        color: theme.animations === key ? customAccent : '#64748b',
                        cursor: 'pointer',
                        textAlign: 'left',
                        transition: `all ${duration} ${easing}`
                      }}
                      onMouseEnter={(e) => {
                        if (theme.animations !== key) {
                          e.target.style.transform = 'translateY(-2px)';
                          e.target.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
                        }
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = 'translateY(0)';
                        e.target.style.boxShadow = 'none';
                      }}
                    >
                      <div style={{ fontWeight: '600', marginBottom: '4px' }}>{name}</div>
                      <div style={{ fontSize: '12px', opacity: 0.7 }}>
                        Duration: {duration} • Easing: {easing}
                      </div>
                    </button>
                  ))}
                </div>
              </div>

              {/* Shadow & Depth */}
              <div className="control-group" style={{ marginBottom: '24px' }}>
                <label style={{ fontSize: '16px', fontWeight: '600', marginBottom: '12px', display: 'block' }}>
                  Shadow Depth
                </label>
                <div style={{ display: 'flex', gap: '8px' }}>
                  {[
                    { key: 'none', label: 'None', shadow: 'none' },
                    { key: 'subtle', label: 'Subtle', shadow: '0 1px 3px rgba(0,0,0,0.1)' },
                    { key: 'medium', label: 'Medium', shadow: '0 4px 12px rgba(0,0,0,0.15)' },
                    { key: 'elevated', label: 'Elevated', shadow: '0 8px 25px rgba(0,0,0,0.2)' }
                  ].map(({ key, label, shadow }) => (
                    <button
                      key={key}
                      onClick={() => {/* Add shadow handler */}}
                      style={{
                        flex: 1,
                        padding: '16px 12px',
                        border: '2px solid #e2e8f0',
                        borderRadius: '8px',
                        background: 'white',
                        cursor: 'pointer',
                        fontSize: '14px',
                        fontWeight: '500',
                        boxShadow: shadow,
                        transition: 'all 0.2s ease'
                      }}
                    >
                      {label}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* Presets Tab */}
          {activeTab === 'presets' && (
            <div className="presets-tab">
              {/* Theme Presets */}
              <div className="control-group" style={{ marginBottom: '24px' }}>
                <label style={{ fontSize: '16px', fontWeight: '600', marginBottom: '12px', display: 'block' }}>
                  Quick Presets
                </label>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '12px' }}>
                  {Object.entries(THEME_PRESETS).map(([key, preset]) => (
                    <button
                      key={key}
                      onClick={() => handlePresetApply(preset)}
                      style={{
                        padding: '16px',
                        border: '2px solid #e2e8f0',
                        borderRadius: '12px',
                        background: 'white',
                        cursor: 'pointer',
                        textAlign: 'left',
                        transition: 'all 0.2s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.borderColor = preset.accent;
                        e.target.style.background = `${preset.accent}05`;
                        e.target.style.transform = 'translateY(-2px)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.borderColor = '#e2e8f0';
                        e.target.style.background = 'white';
                        e.target.style.transform = 'translateY(0)';
                      }}
                    >
                      <div style={{
                        width: '100%',
                        height: '32px',
                        background: `linear-gradient(135deg, ${preset.accent}, ${preset.bg})`,
                        borderRadius: '6px',
                        marginBottom: '12px',
                        border: '1px solid rgba(0,0,0,0.1)'
                      }} />
                      <div style={{ fontWeight: '600', fontSize: '14px', marginBottom: '4px', color: '#1f2937' }}>
                        {preset.name}
                      </div>
                      <div style={{ fontSize: '12px', color: '#64748b', lineHeight: '1.4' }}>
                        {preset.description}
                      </div>
                    </button>
                  ))}
                </div>
              </div>

              {/* Save/Load Custom Themes */}
              <div className="control-group" style={{ marginBottom: '24px' }}>
                <label style={{ fontSize: '16px', fontWeight: '600', marginBottom: '12px', display: 'block' }}>
                  Custom Themes
                </label>
                
                {/* Save Theme */}
                <div style={{ display: 'flex', gap: '8px', marginBottom: '16px' }}>
                  <input
                    type="text"
                    value={themeName}
                    onChange={(e) => setThemeName(e.target.value)}
                    placeholder="Enter theme name..."
                    style={{
                      flex: 1,
                      padding: '12px',
                      border: '2px solid #e2e8f0',
                      borderRadius: '8px',
                      fontSize: '14px',
                      outline: 'none'
                    }}
                    onFocus={(e) => e.target.style.borderColor = customAccent}
                    onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
                  />
                  <button
                    onClick={handleSaveTheme}
                    disabled={!themeName.trim()}
                    style={{
                      padding: '12px 16px',
                      background: themeName.trim() ? customAccent : '#e2e8f0',
                      color: themeName.trim() ? 'white' : '#94a3b8',
                      border: 'none',
                      borderRadius: '8px',
                      cursor: themeName.trim() ? 'pointer' : 'not-allowed',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      fontSize: '14px',
                      fontWeight: '500',
                      transition: 'all 0.2s ease'
                    }}
                  >
                    <IconSave />
                    Save
                  </button>
                </div>

                {/* Saved Themes List */}
                {savedThemes.length > 0 && (
                  <div style={{
                    maxHeight: '300px',
                    overflowY: 'auto',
                    border: '1px solid #e2e8f0',
                    borderRadius: '8px',
                    background: '#f8fafc'
                  }}>
                    {savedThemes.map((saved) => (
                      <div
                        key={saved.id}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          padding: '12px 16px',
                          borderBottom: '1px solid #e2e8f0',
                          background: 'white',
                          margin: '8px',
                          borderRadius: '6px'
                        }}
                      >
                        <div style={{ flex: 1 }}>
                          <div style={{ fontWeight: '600', fontSize: '14px', color: '#1f2937' }}>
                            {saved.name}
                          </div>
                          <div style={{ fontSize: '12px', color: '#64748b' }}>
                            Saved {new Date(saved.createdAt).toLocaleDateString()}
                          </div>
                        </div>
                        <div style={{
                          width: '24px',
                          height: '24px',
                          borderRadius: '4px',
                          background: saved.accent,
                          marginRight: '12px',
                          border: '1px solid rgba(0,0,0,0.1)'
                        }} />
                        <div style={{ display: 'flex', gap: '8px' }}>
                          <button
                            onClick={() => handleLoadTheme(saved)}
                            style={{
                              padding: '6px 12px',
                              background: customAccent,
                              color: 'white',
                              border: 'none',
                              borderRadius: '6px',
                              cursor: 'pointer',
                              fontSize: '12px',
                              fontWeight: '500',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '4px'
                            }}
                          >
                            <IconEye />
                            Load
                          </button>
                          <button
                            onClick={() => handleDeleteTheme(saved.id)}
                            style={{
                              padding: '6px 8px',
                              background: '#ef4444',
                              color: 'white',
                              border: 'none',
                              borderRadius: '6px',
                              cursor: 'pointer',
                              fontSize: '12px',
                              display: 'flex',
                              alignItems: 'center'
                            }}
                          >
                            <IconTrash />
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                {savedThemes.length === 0 && (
                  <div style={{
                    textAlign: 'center',
                    padding: '40px 20px',
                    color: '#64748b',
                    fontSize: '14px',
                    border: '2px dashed #e2e8f0',
                    borderRadius: '8px'
                  }}>
                    <IconPalette style={{ marginBottom: '8px', opacity: 0.5 }} />
                  <div>No saved themes yet</div>
                  <div style={{ fontSize: '12px', marginTop: '4px' }}>
                    Create and save your first custom theme!
                  </div>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>

        {/* Live Preview Section */}
        <div style={{
          margin: '0 24px 24px 24px',
          padding: '20px',
          borderRadius: '12px',
          background: customAccent,
          color: 'white',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <div style={{
            position: 'absolute',
            top: 0,
            right: 0,
            padding: '8px 12px',
            background: 'rgba(0,0,0,0.1)',
            borderBottomLeftRadius: '8px',
            fontSize: '12px',
            fontWeight: '600'
          }}>
            <IconEye style={{ marginRight: '4px' }} />
            Live Preview
          </div>
          
          <h3 style={{ margin: '0 0 16px 0', fontSize: `${theme.fontSize || 16}px` }}>
            Your App Preview
          </h3>
          
          <div style={{ display: 'flex', gap: '12px', marginBottom: '16px', flexWrap: 'wrap' }}>
            <button style={{
              background: 'rgba(255,255,255,0.9)',
              color: customAccent,
              border: 'none',
              borderRadius: theme.buttonShape === 'pill' ? '999px' : theme.buttonShape === 'square' ? '0' : '8px',
              fontSize: `${(theme.fontSize || 16) - 2}px`,
              padding: '8px 16px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.2s ease'
            }}>
              Primary Action
            </button>
            
            <button style={{
              background: 'transparent',
              color: 'white',
              border: '2px solid rgba(255,255,255,0.3)',
              borderRadius: theme.buttonShape === 'pill' ? '999px' : theme.buttonShape === 'square' ? '0' : '8px',
              fontSize: `${(theme.fontSize || 16) - 2}px`,
              padding: '8px 16px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.2s ease'
            }}>
              Secondary Action
            </button>
          </div>

          <div style={{
            background: 'rgba(255,255,255,0.1)',
            borderRadius: '8px',
            padding: '12px',
            fontSize: '14px',
            lineHeight: '1.5'
          }}>
            <div style={{ fontWeight: '600', marginBottom: '8px' }}>
              Theme Configuration:
            </div>
            <div style={{ fontSize: '12px', opacity: 0.9 }}>
              Mode: {theme.mode} • Font: {theme.fontSize || 16}px • 
              Buttons: {theme.buttonShape} • Spacing: {theme.spacing || 'comfortable'}
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div style={{
          padding: '0 24px 24px 24px',
          display: 'flex',
          gap: '12px',
          justifyContent: 'space-between'
        }}>
          <button
            onClick={resetTheme}
            style={{
              padding: '12px 20px',
              background: 'transparent',
              color: '#64748b',
              border: '2px solid #e2e8f0',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.borderColor = '#ef4444';
              e.target.style.color = '#ef4444';
            }}
            onMouseLeave={(e) => {
              e.target.style.borderColor = '#e2e8f0';
              e.target.style.color = '#64748b';
            }}
          >
            <FiRefreshCw size={16} />
            Reset to Default
          </button>

          <div style={{ display: 'flex', gap: '8px' }}>
            <button
              onClick={() => setShowAdvanced(!showAdvanced)}
              style={{
                padding: '12px 16px',
                background: '#f1f5f9',
                color: '#475569',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: '500',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}
            >
              <FiSettings size={16} />
              Advanced
              {showAdvanced ? <FiChevronUp size={14} /> : <FiChevronDown size={14} />}
            </button>
            
            <button
              style={{
                padding: '12px 20px',
                background: customAccent,
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: '600',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
              }}
              onClick={() => setShowToast({ type: 'success', message: 'Theme applied successfully!' })}
            >
              <FiCheck size={16} />
              Apply Theme
            </button>
          </div>
        </div>

        {/* Advanced Settings (Collapsible) */}
        {showAdvanced && (
          <div style={{
            margin: '0 24px 24px 24px',
            padding: '20px',
            background: '#f8fafc',
            borderRadius: '12px',
            border: '1px solid #e2e8f0'
          }}>
            <h4 style={{ margin: '0 0 16px 0', fontSize: '16px', fontWeight: '600' }}>
              Advanced Settings
            </h4>
            
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px' }}>
              <div>
                <label style={{ fontSize: '14px', fontWeight: '500', marginBottom: '8px', display: 'block' }}>
                  CSS Export Format
                </label>
                <select style={{
                  width: '100%',
                  padding: '8px',
                  border: '1px solid #e2e8f0',
                  borderRadius: '6px',
                  fontSize: '14px'
                }}>
                  <option>CSS Variables</option>
                  <option>SCSS Variables</option>
                  <option>JSON Theme</option>
                </select>
              </div>
              
              <div>
                <label style={{ fontSize: '14px', fontWeight: '500', marginBottom: '8px', display: 'block' }}>
                  Auto-apply Changes
                </label>
                <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px' }}>
                  <input type="checkbox" defaultChecked />
                  Live preview mode
                </label>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default EnhancedThemeCustomizer;